import { getAsyncDataKey } from '@/constants/async-data-keys'

interface UseAsyncDataKeyOptions {
  withLocale?: boolean
}

export function useAsyncDataKey(baseKey: string, params: (string | number)[] = [], options: UseAsyncDataKeyOptions = {}) {
  const { withLocale = true } = options
  const { locale } = useI18n()
  // 取當下的 snapshot，不能是 reactive：setLocale 會先改 locale 再轉址，若 locale 是 reactive 會導致部分 API 在轉址前多 call 一次
  const currentLocale = locale.value

  return getAsyncDataKey(baseKey, withLocale ? [...params, currentLocale] : params)
}
